/**
 * Shared critical city lists for tenant configurations.
 * 
 * These are common lists that can be reused across tenants,
 * but tenants can still override with their own custom lists if needed.
 */

/**
 * Critical cities for Canadian tenants
 * Major metropolitan areas across Canada
 * Format: 'city-province' (e.g., 'toronto-on')
 */
export const CRITICAL_CITIES_CA = [
  'toronto-on',
  'vancouver-bc',
  'calgary-ab',
  'ottawa-on',
  'montreal-qc',
] as const;

/**
 * Critical cities for US tenants
 * Major metropolitan areas with high market activity
 * Format: 'city-state' (e.g., 'tampa-fl')
 */
export const CRITICAL_CITIES_US = [
  'tampa-fl',
  'orlando-fl',
  'miami-fl',
  'phoenix-az',
  'las-vegas-nv',
] as const;

